import {
  type ComponentProps,
  type ComponentType,
  CSSProperties,
  forwardRef,
} from 'react';
import cl from 'clsx';

import { Spinner } from '@synapex/frontend-shared/ui/Loading';

import classes from './Button.module.scss';

export type ButtonProps = ComponentProps<'button'> & {
  PrefixIcon?: ComponentType<ComponentProps<'svg'>>;
  prefixIconStyle?: CSSProperties;
  SuffixIcon?: ComponentType<ComponentProps<'svg'>>;
  variant: 'primary' | 'secondary';
  loading?: boolean;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(
    {
      type = 'button',

      PrefixIcon,
      prefixIconStyle,
      SuffixIcon,
      variant,

      children,
      className,

      loading = false,
      disabled: disabledProp,

      ...rest
    },
    ref,
  ) {
    const disabled = disabledProp || loading;
    return (
      <button
        type={type}
        ref={ref}
        disabled={disabled}
        className={cl(
          classes.root,
          classes[variant],
          { [classes.loading]: loading },
          className,
        )}
        {...rest}
      >
        {PrefixIcon && (
          <PrefixIcon className={classes.icon} style={prefixIconStyle} />
        )}
        <div className={classes.content}>{children}</div>
        {SuffixIcon && <SuffixIcon className={classes.icon} />}
        {loading && (
          <Spinner
            size={28}
            thickness={2}
            color={'#fff'}
            className={classes.spinner}
          />
        )}
      </button>
    );
  },
);
